import React from "react";

import { IEspmPropertyTypeDetailNode } from "../../../services/zeos-api/contracts/EspmPropertyType";
import { ZeosLabel } from "../ZeosLabel";

interface IProps {
  details: IEspmPropertyTypeDetailNode[];
  value?: number;
  onChange: (detailId: number | undefined) => void;
  requiresSubtype: boolean;
  disabled?: boolean;
  error?: string;
}

export const EspmSubtypeSelect: React.FC<IProps> = ({
  details,
  value,
  onChange,
  requiresSubtype,
  disabled = false,
  error,
}) => {
  return (
    <div className="w-full border-l-4 border-zeos-blue/20 pl-4">
      <ZeosLabel
        label="Property Subtype"
        required={requiresSubtype}
      />
      {!requiresSubtype && (
        <span className="text-xs text-gray-500 -mt-1 mb-1 block">(optional)</span>
      )}
      <select
        value={value != null ? String(value) : ""}
        disabled={disabled}
        onChange={(e) => {
          const next = e.target.value;
          onChange(next ? Number(next) : undefined);
        }}
        className={`
          w-full rounded border px-3 py-2 min-h-[48px]
          bg-white text-[1.125rem] text-zeos-black font-light font-sans
          focus:outline-none focus:ring-2 focus:ring-zeos-blue
          disabled:opacity-60
          ${error ? "border-red-500" : "border-[#929293]"}
        `}
      >
        <option value="">Select a subtype…</option>
        {details.map((d) => (
          <option
            key={d.espmPropertyTypeDetailId}
            value={d.espmPropertyTypeDetailId}
          >
            {d.itemName}
          </option>
        ))}
      </select>
      <p className="text-xs text-gray-500 mt-1.5">
        Adds ESPM Level-2 detail for this category.
      </p>
      {error && <div className="text-orange-500 text-xs mt-1">{error}</div>}
    </div>
  );
};
